export function holderIdentity(raw: string | null | undefined, company = false) {
 const value=raw?.trim() || 'Nominativo non indicato';
 if(company)return {name:value,birthDate:null,needsReview:false};
 const date=value.match(/\b(\d{2}\/\d{2}\/\d{4})\b/);
 const residue=value.search(/\s+(?:\d{1,2}\/|\/\d)/);
 const name=(residue>=0?value.slice(0,residue):value).trim();
 return {name,birthDate:date?.[1] ?? null,needsReview:residue>=0&&!date};
}
export function propertyLabel(kind: string, category: string | null) {
 if(kind==='terreno')return 'Terreno';
 if(category==='A/10')return 'Ufficio';
 if(category?.startsWith('A/'))return 'Abitazione';
 return ({'C/6':'Autorimessa','C/2':'Deposito','C/1':'Negozio'} as Record<string,string>)[category ?? ''] || (kind==='fabbricato'?'Fabbricato':'Immobile');
}
export function consistencyLabel(category:string|null,value:string|null) {
 if(!value)return 'Non indicata';
 return value+(category?.startsWith('A/')?' vani':category?.startsWith('C/')?' m²':category?.startsWith('B/')?' m³':'');
}
export function euro(value:string|null) {
 if(!value)return 'Non indicata';
 const n=Number(value.includes(',')?value.replace(/\./g,'').replace(',','.'):value);
 return Number.isFinite(n)?new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(n):value;
}

export function propertyAddress(value:string|null) {
 if(!value)return {street:'Indirizzo non riportato nella visura',interno:null,piano:null};
 const interno=value.match(/\bInterno\s+(.+?)(?=\s+Piano\b|$)/i)?.[1]??null;
 const piano=value.match(/\bPiano\s+(.+)$/i)?.[1]??null;
 return {street:value.split(/\s+(?:Interno|Piano)\s+/i)[0],interno,piano};
}

const PLACE_PARTICLES=new Set(['di','de','del','della','delle','dei','degli','dello','da','e']);
/** SISTER scrive indirizzi e comuni in maiuscolo: in lista si leggono meglio in forma normale. */
export function placeCase(value:string) {
 let first=true;
 return value.toLocaleLowerCase('it-IT').replace(/\p{L}+/gu,word=>{
  const keep=!first&&PLACE_PARTICLES.has(word);first=false;
  return keep?word:word[0]!.toLocaleUpperCase('it-IT')+word.slice(1);
 });
}
/** Riga d'indirizzo per la lista: "Via Arpi 45, Foggia", oppure "Terreno a San Severo" senza indirizzo. */
export function listAddress(im:{kind:string;categoria:string|null;comune:string|null;indirizzo:string|null}) {
 const comune=im.comune?.trim()?placeCase(im.comune.trim()):null;
 const street=im.indirizzo?.trim()?propertyAddress(im.indirizzo).street.replace(/\s+n\.\s*SNC\b/i,'').replace(/\s+n\.\s*/i,' ').replace(/\s+/g,' ').trim():'';
 if(street)return comune?`${placeCase(street)}, ${comune}`:placeCase(street);
 return comune?`${propertyLabel(im.kind,im.categoria)} a ${comune}`:null;
}
